<template>
  <input-dropdown :options="mappedTanks" :value="tankId" @change="handleInput"/>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import InputDropdown from "../../input/Dropdown";
import googleAnalyticsMixin from '@/mixins/googleAnalyticsMixin';

export default {
  name: 'TankDropdown',

  components: {
    InputDropdown
  },

  mixins: [googleAnalyticsMixin],

  computed: {
    ...mapState({
      tankId: state => state.build.tank,
    }),
    ...mapGetters({
      tanks: 'tanks/getTanks',
      best: 'build/getBestTank',
      availableTanks: 'tanks/getAvailableTanks'
    }),

    mappedTanks() {
      return this.availableTanks
          .map(tank => {
            return {
              key: tank.id,
              value: this.translate(tank.name),
              recommended: this.best === tank.id,
            }
          });
    }
  },

  methods: {
    handleInput(id) {
      this.pushDataLayer({
        step: this.gaData.steps.step4,
        interaction_type: this.gaData.interactionTypes.click,
        field: 'tank',
        value: this.gaData.undefined,
        build_id: this.gaData.undefined
      });

      this.$store.dispatch('build/setTank', id);
      this.$store.dispatch('openFrameOptions/reset', []);
    }
  }
}
</script>
